var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Colors, Spacing, Text } from '@doordash/design-language';
import Loading from '@doordash/component-loading';
import * as React from 'react';
import styled from 'styled-components';
import { PORTAL_ROUTE_PREFIX } from '../../constants/values';
import { RedirectToContainer } from '../testId';
var FullHeightCenteredContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 100vh;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: ", "px 0;\n  text-align: center;\n  & > * {\n    padding-top: ", "px;\n  }\n"], ["\n  min-height: 100vh;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: ", "px 0;\n  text-align: center;\n  & > * {\n    padding-top: ", "px;\n  }\n"])), Spacing.XxLarge, Spacing.Large);
var RedirectTo = function (props) {
    var _a, _b;
    var matchedPath = (_a = props === null || props === void 0 ? void 0 : props.matchedPath) !== null && _a !== void 0 ? _a : '';
    var pathName = (_b = props === null || props === void 0 ? void 0 : props.pathname) !== null && _b !== void 0 ? _b : '';
    var backupRedirectPath = PORTAL_ROUTE_PREFIX;
    var redirectPath = pathName.replace(matchedPath, '');
    var validRedirectParams = Boolean(redirectPath);
    var finalRedirectPath = validRedirectParams
        ? "https://www.doordash.com" + (redirectPath.startsWith('/') ? redirectPath : '/' + redirectPath)
        : backupRedirectPath;
    React.useEffect(function () {
        window.location.href = finalRedirectPath;
    }, [finalRedirectPath]);
    return (React.createElement(FullHeightCenteredContainer, { "data-testid": RedirectToContainer },
        React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.Title1 }, "Redirecting, please wait..."),
        React.createElement(Text, { color: Text.Colors.TextTertiary, styles: Text.Styles.Title2 },
            React.createElement("a", { href: finalRedirectPath }, "Click here"),
            " if you are not automatically redirected"),
        React.createElement(Loading, { size: Loading.Sizes.Small, color: Colors.SystemRed70 })));
};
export default RedirectTo;
var templateObject_1;
